namespace Matrix.Data {
    export interface TestGroupTestRow {
        TestGroupCode?: string;
        TestCode?: string;
        SequenceNumber?: number;
        ParameterBinding?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TestGroupCodeDescription?: string;
        TestGroupCodeLastRunBatchId?: number;
        TestGroupCodePassCount?: number;
        TestGroupCodeFailCount?: number;
        TestGroupCodeWarnCount?: number;
        TestGroupCodeIgnoreCount?: number;
        TestGroupCodeErrorCount?: number;
        TestCodeDescription?: string;
        TestCodeEnabled?: boolean;
        TestCodeTestTypeCode?: string;
        TestCodePriority?: string;
        TestCodeScript?: string;
        TestCodeLastRunBatchId?: number;
        TestCodeLastResultCode?: string;
    }

    export namespace TestGroupTestRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'TestGroupCode';
        export const localTextPrefix = 'Data.TestGroupTest';
        export const deletePermission = 'DataAdmin:TestGroupTest';
        export const insertPermission = 'DataAdmin:TestGroupTest';
        export const readPermission = 'Read:TestGroupTest';
        export const updatePermission = 'DataAdmin:TestGroupTest';

        export declare const enum Fields {
            TestGroupCode = "TestGroupCode",
            TestCode = "TestCode",
            SequenceNumber = "SequenceNumber",
            ParameterBinding = "ParameterBinding",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TestGroupCodeDescription = "TestGroupCodeDescription",
            TestGroupCodeLastRunBatchId = "TestGroupCodeLastRunBatchId",
            TestGroupCodePassCount = "TestGroupCodePassCount",
            TestGroupCodeFailCount = "TestGroupCodeFailCount",
            TestGroupCodeWarnCount = "TestGroupCodeWarnCount",
            TestGroupCodeIgnoreCount = "TestGroupCodeIgnoreCount",
            TestGroupCodeErrorCount = "TestGroupCodeErrorCount",
            TestCodeDescription = "TestCodeDescription",
            TestCodeEnabled = "TestCodeEnabled",
            TestCodeTestTypeCode = "TestCodeTestTypeCode",
            TestCodePriority = "TestCodePriority",
            TestCodeScript = "TestCodeScript",
            TestCodeLastRunBatchId = "TestCodeLastRunBatchId",
            TestCodeLastResultCode = "TestCodeLastResultCode"
        }
    }
}
